import { defineMessages } from 'react-intl';

/**
 * Translatable display words for hotkey chord rendering. Glyphs, punctuation,
 * and universal abbreviations (Alt/Win/fn/Esc) are kept literal in
 * `platformKeyNames.ts` and intentionally excluded here. Caps Lock, Backspace,
 * and Enter/Return render as glyphs (⇪ ⌫ ⏎) so they are excluded too.
 */
export const platformKeyMessages = defineMessages({
  left: {
    defaultMessage: 'Left',
    id: 'Is4nDaWR5V',
    description: 'Side label for a left-side modifier key in a hotkey chord',
  },
  right: {
    defaultMessage: 'Right',
    id: 'HmjyexWpC+',
    description: 'Side label for a right-side modifier key in a hotkey chord',
  },
  ctrl: {
    defaultMessage: 'Ctrl',
    id: 'J3i7+uVQxy',
    description: 'Windows Control modifier key label in a hotkey chord',
  },
  space: {
    defaultMessage: 'Space',
    id: 'cyngsTXDL8',
    description: 'Space bar key label in a hotkey chord',
  },
  tab: {
    defaultMessage: 'Tab',
    id: 'qYNkxT1PgW',
    description: 'Tab key label in a hotkey chord',
  },
  delete: {
    defaultMessage: 'Delete',
    id: '+4oz/MGHzE',
    description: 'Windows Delete key label in a hotkey chord',
  },
  forwardDelete: {
    defaultMessage: 'Forward Delete',
    id: 'nMmiwtpZBq',
    description: 'macOS forward delete key label in a hotkey chord',
  },
  insert: {
    defaultMessage: 'Insert',
    id: 'T/2JizQXSL',
    description: 'Insert key label in a hotkey chord',
  },
  home: {
    defaultMessage: 'Home',
    id: 'lCjnehZVnu',
    description: 'Home key label in a hotkey chord',
  },
  end: {
    defaultMessage: 'End',
    id: 'K6yWcqq73P',
    description: 'End key label in a hotkey chord',
  },
  help: {
    defaultMessage: 'Help',
    id: 'MYzl+raZfn',
    description: 'macOS Help key label in a hotkey chord',
  },
  contextMenu: {
    defaultMessage: 'Menu',
    id: 'sWZTkTp9W+',
    description: 'Windows context-menu key label in a hotkey chord',
  },
  pause: {
    defaultMessage: 'Pause',
    id: 'AsQ+GXbkls',
    description: 'Pause/Break key label in a hotkey chord',
  },
  pageUp: {
    defaultMessage: 'Page Up',
    id: 'MqHQEgY25q',
    description: 'Page Up key label in a hotkey chord',
  },
  pageDown: {
    defaultMessage: 'Page Down',
    id: 'KFvzqaAGKZ',
    description: 'Page Down key label in a hotkey chord',
  },
  numLock: {
    defaultMessage: 'Num Lock',
    id: 'm8ze9Cly+o',
    description: 'Num Lock key label in a hotkey chord',
  },
  scrollLock: {
    defaultMessage: 'Scroll Lock',
    id: 'WHTSwbgch1',
    description: 'Scroll Lock key label in a hotkey chord',
  },
  printScreen: {
    defaultMessage: 'Print Screen',
    id: 'pi5K9aT4Dd',
    description: 'Print Screen key label in a hotkey chord',
  },
});
